import React, { useState } from 'react';
import {Route, Redirect} from 'react-router-dom'
import { useSelector } from 'react-redux';

const PrivateRoute = ({ children, ...rest }) => {
    // const {loggedUser} = useSelector(state => ({
    //     loggedUser: state.loggedUser
    // }))

    return (
        <Route
            {...rest}
            render={({ location }) =>
            // loggedUser && loggedUser.session ? 
              children(location)
              // : (
              // <Redirect
              //   to={{
              //       pathname: "/flashscreen",
              //       state: { from: location }
              //   }}
              // />
            // )
            }
        />
    );
}

export default PrivateRoute